import React, { useState } from "react";
import axios from "axios";
import logolight from "../../assets/images/logo.svg";
import logodark from "../../assets/images/logo.svg";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { ToastContainer,toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";


const RecoverPassword = () => {
  document.title = "Recover Password | Linc";
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const emailRegex =
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=<>?{}[\]~])[A-Za-z\d!@#$%^&*()_\-+=<>?{}[\]~]{8,25}$/;

  const clearError = (field) => {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    })
  }

  /* ================= STEP 1 ================= */
  const submitEmail = async () => {
    let tempErrors = {};

    if (!email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      tempErrors.email = "Enter a valid email address";
    }

    if (Object.keys(tempErrors).length > 0) {
      setErrors(tempErrors);
      return;
    }
    setErrors({});
    setLoading(true);
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "forgot_password/",
        { user_email: email }
      );
      console.log("res", res)
      if (res?.status === "success" && res["2fa_required"] === true) {
        setToken(res.token);
        setStep(2);
        toast.success(res.message);
      } else if (res.status === "error") {
        toast.error(res.message);
      }

    } catch {
      setMessage();
    } finally {
      setLoading(false);
    }
  };

  /* ================= STEP 2 ================= */
  const verifyOtp = async () => {
    let tempErrors = {};
    if (!otp) {
      tempErrors.otp = "OTP required"
    }
    // if (!otp) {
    //   setMessage("OTP required");
    //   return;
    // }

    setErrors({})
    setLoading(true);
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "verify_otp/",
        { otp, token }
      );
      console.log("res1", res)

      if (res?.status === "success") {
        setStep(3);
        toast.success(res?.message);
      } else if (res?.status === "error") {
        toast.error(res?.message);
      }
    } catch {
      setMessage("Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
   const res = await axios.post(
      process.env.REACT_APP_API_BASE_URL + "resend_otp/",
      { token }
    );
   if (res?.status === "success") {
        toast.success(res?.message);
      } else if (res?.status === "error") {
        toast.error(res?.message);
      }
  };

  /* ================= STEP 3 ================= */
  const resetPassword = async () => {
    let tempErrors = {};

    if (!newPassword) {
      tempErrors.newPassword = "New password is required";
    } else if (newPassword.length < 8) {
      tempErrors.newPassword = "Password must be at least 8 characters";
    } else if (newPassword.length > 25) {
      tempErrors.newPassword = "Password cannot exceed 25 characters";
    } else if (!passwordRegex.test(newPassword)) {
      tempErrors.newPassword = "Password must contain uppercase, lowercase, number, and special character";
    }

    if (!confirmPassword) {
      tempErrors.confirmPassword = "Confirm password is required";
    } else if (confirmPassword !== newPassword) {
      tempErrors.confirmPassword = "Passwords do not match";
    }

    if (Object.keys(tempErrors).length > 0) {
      setErrors(tempErrors);
      return;
    }
    setErrors({})
    setLoading(true);
    try {
      const res = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "reset_password/",
        {
          token,
          new_password: newPassword,
        }
      );
      console.log("res2", res)

      if (res?.status === "success") {
        toast.success(res?.message);
         setTimeout(() => {
          navigate("/login");
          window.location.reload(); // ensure state resets
        }, 6000);
      } else if (res?.status === "error") {
        toast.error(res?.message);
      }
    } catch {
      setMessage("Password reset failed");
    } finally {
      setLoading(false);
    }
  };


  return (
    <React.Fragment>
      <div className="bg-pattern" style={{ height: "100vh" }}>
        <div className="bg-overlay"></div>
        <div className="account-pages d-flex flex-column justify-content-center" style={{ height: "100vh" }}>
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card className="mt-5">
                  <CardBody className="p-4">
                    {/* <div className="mt-3">
                      <Link to="/login" className="btn btn-primary">
                        ←
                      </Link>
                    </div> */}
                    <div className="text-center">
                      <Link to="/login">
                        <img src={logodark} alt="" className="auth-logo logo-dark mx-auto" style={{ width: '150px' }} />
                        <img src={logolight} alt="" className="auth-logo logo-light mx-auto" style={{ width: '150px' }} />
                      </Link>
                    </div>

                    <h4 className="font-size-18 text-muted mt-2 text-center">Reset Password</h4>
                    <p className="mb-5 text-center">Reset your Password with Linc.</p>

                    {/* Your Message UI */}
                    {message && (
                      <div className="alert alert-warning alert-dismissible fade show">
                        {message}
                        <button type="button" className="btn-close" data-bs-dismiss="alert"></button>
                      </div>
                    )}

                    {/* ======= STEP FORMS ======= */}
                    {step === 1 && (
                      <form className="form-horizontal" onSubmit={(e) => { e.preventDefault(); submitEmail(); }}>
                        <Row>
                          <Col md={12}>
                            <div className="mt-3">
                              <label className="form-label" htmlFor="useremail">Email</label>
                              <input
                                type="email"
                                className="form-control"
                                value={email}
                                placeholder="Enter Email"
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  clearError("email")
                                }}
                              />
                              {errors.email && (
                                <small className="text-danger">{errors.email}</small>
                              )}
                            </div>
                            <div className="d-grid mt-4">
                              <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Sending..." : "Send Email"}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}

                    {step === 2 && (
                      <form className="form-horizontal" onSubmit={(e) => { e.preventDefault(); verifyOtp(); }}>
                        <Row>
                          <Col md={12}>
                            <div className="mt-3">
                              <label className="form-label" htmlFor="otp">Enter OTP</label>
                              <p className="text-muted">The OTP will Expire in 2 Minutes.</p>
                              <input
                                type="text"
                                className="form-control"
                                id="otp"
                                value={otp}
                                placeholder="Enter OTP"
                                onChange={(e) => {
                                  setOtp(e.target.value)
                                  clearError("otp");
                                }}
                              />
                              {errors.otp && (
                                <small className="text-danger">{errors.otp}</small>
                              )}
                            </div>
                            <div className="d-grid mt-4">
                              <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Verifying..." : "Verify OTP"}
                              </button>
                            </div>
                            <div className="text-center mt-2">
                              <button type="button" className="btn btn-link" onClick={resendOtp}>Resend OTP</button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}

                    {step === 3 && (
                      <form className="form-horizontal" onSubmit={(e) => { e.preventDefault(); resetPassword(); }}>
                        <Row>
                          <Col md={12}>
                            <div className="position-relative">
                              <label className="form-label" htmlFor="newpassword">New Password</label>
                              <input
                                type={showNewPassword ? "text" : "password"}
                                className="form-control"
                                value={newPassword}
                                placeholder="New Password"
                                onChange={(e) => {
                                  setNewPassword(e.target.value);
                                  clearError("newPassword");
                                }}
                              />
                              <span className="password-toggle-forgot pointer" onClick={() => setShowNewPassword(!showNewPassword)}>
                                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                              {errors.newPassword && (
                                <small className="text-danger">{errors.newPassword}</small>
                              )}
                            </div>
                            <div className="position-relative">
                              <label className="form-label" htmlFor="confirmpassword">Confirm Password</label>
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="form-control"
                                value={confirmPassword}
                                placeholder="Confirm Password"
                                onChange={(e) => {
                                  setConfirmPassword(e.target.value);
                                  clearError("confirmPassword")
                                }}
                              />
                              <span className="password-toggle-forgot pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                              </span>
                              {errors.confirmPassword && (
                                <small className="text-danger">{errors.confirmPassword}</small>
                              )}
                            </div>
                            <div className="d-grid mt-4">
                              <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? "Submitting..." : "Reset Password"}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    )}
                    {/* ======= END STEP FORMS ======= */}

                  </CardBody>
                </Card>

                <div className="mt-5 text-center"></div>

              </Col>
            </Row>
          </Container>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RecoverPassword;
